import React, { useEffect, useState } from "react";
import { optimizeStoreImage, resolveAssetUrl } from "@/lib/assetUrl";

/**
 * Store/catalog image that loads a compressed WebP thumbnail first.
 * Falls back to the original file if the optimizer is unreachable.
 */
export default function StoreImg({
  src,
  alt = "",
  width = 480,
  quality = 70,
  className,
  loading = "lazy",
  decoding = "async",
  fetchPriority,
  onError,
  ...rest
}) {
  const original = resolveAssetUrl(src);
  const optimized = original ? optimizeStoreImage(original, { width, quality }) : "";
  const [useOriginal, setUseOriginal] = useState(false);

  useEffect(() => {
    setUseOriginal(false);
  }, [original]);

  if (!original) return null;

  return (
    <img
      src={useOriginal ? original : optimized}
      alt={alt}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      className={className}
      onError={(e) => {
        if (!useOriginal && optimized !== original) {
          setUseOriginal(true);
          return;
        }
        onError?.(e);
      }}
      {...rest}
    />
  );
}
